<template>
  <Modal
    ref="modal"
    title="New Teammate Settings"
    action="Save"
    action-color="indigo"
    @close-modal="handleCancelSettings"
    @handle-action="updateTeam"
  >
    <TextAreaInput
      v-if="loaded"
      label="Initial Referral Message"
      rows="6"
      :model-value="team.initialReferralMessage"
      @update:model-value="team.initialReferralMessage = $event"
    />
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    Modal,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      loaded: false,
      team: {
        id: '',
        initialReferralMessage: '',
      },
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
    getTeam() {
      const self = this;
      fetch('/api/team')
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.team.id = data.id;
          self.team.initialReferralMessage = data.record.initial_referral_message;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/api/team', {
        method: 'PUT',
        body: JSON.stringify({
          initial_referral_message: self.team.initialReferralMessage,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('Workflow updated', {
              action: { label: 'Dismiss' },
              description: 'Your workflow was successfully updated.  Use the button below to dismiss this alert.',
            });
            this.$emit('handleSaveSettings');
          } else {
            toast.error('Workflow update error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
